/* eslint-disable @typescript-eslint/indent */
import { Typography } from '@pwskills/rachnaui';
import { classNames } from '@pwskills/rachnaui/utils';
import React from 'react';

const GlimpsesCard = ({
  glimpsesInfo,
  currentTarget,
  cardIndex,
  isMobile,
  isPlaying,
}: {
  glimpsesInfo: any;
  currentTarget: number;
  cardIndex: number;
  isMobile: boolean;
  isPlaying: boolean;
}) => {
  const Glimpses = [
    {
      image: '/images/masterclassDescription/glimpses/Glimpses_1.svg',
    },
    {
      image: '/images/masterclassDescription/glimpses/Glimpses_2.svg',
    },
    {
      image: '/images/masterclassDescription/glimpses/Glimpses_3.svg',
    },
    {
      image: '/images/masterclassDescription/glimpses/Glimpses_4.svg',
    },
  ];
  return (
    <div
      className={classNames(
        `w-[194px] flex  gap-2 medium:gap-3 ${
          !isMobile ? (cardIndex % 2 !== 0 ? 'flex-col-reverse' : 'flex-col') : 'flex-col'
        }  opacity-85`
      )}
    >
      <div className="flex flex-col gap-4 medium:gap-1 p-3 rounded-xl shadow-[0px_8px_24px_0px_rgba(0,0,0,0.06)] bg-white">
        <Typography
          component="body-tiny"
          variant="bold"
          className={`!text-[12px] !leading-[18px] ${
            cardIndex === currentTarget && !isPlaying
              ? 'transition-text-weight-glimpses-title'
              : currentTarget > cardIndex
              ? 'font-bold'
              : 'font-normal'
          }`}
        >
          {glimpsesInfo?.time}
        </Typography>
        {Glimpses && (
          <div
            className={`bg-[#FEEAD2] h-[125px] medium:h-[80px] large:h-[96px] w-full ${
              cardIndex === currentTarget && !isPlaying
                ? 'glimpsesCardAnim'
                : currentTarget > cardIndex
                ? 'bg-blend-normal '
                : 'bg-blend-luminosity opacity-80 '
            }`}
            style={{ backgroundImage: `url(${Glimpses[cardIndex]?.image})` }}
          />
        )}
      </div>
      <Typography
        component="body-tiny"
        variant="bold"
        className={`!text-[16px] !leading-[24px] text-center ${
          cardIndex === currentTarget && !isPlaying
            ? 'transition-text-color-glimpses-description'
            : currentTarget > cardIndex
            ? 'text-gray-850 '
            : 'text-gray-400 '
        }`}
      >
        {glimpsesInfo?.title}
      </Typography>
    </div>
  );
};

export default GlimpsesCard;
